<template>
  <div class="flex flex-col h-full w-full" :style="outerStyle">
    <header v-if="$slots.header" class="px-3 py-4 shrink-0 bg-main-nav-bg">
      <slot name="header" />
    </header>

    <main class="grow min-h-0">
      <slot />
    </main>

    <footer v-if="$slots.footer" class="flex justify-around items-center px-3 py-4 bg-main-nav-bg footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  topPadding?: number
  bottomPadding?: number
}>(), {
  topPadding: 0,
  bottomPadding: 0
})

const outerStyle = computed(() => ({
  paddingTop: `${props.topPadding}px`,
  paddingBottom: `${props.bottomPadding}px`,
}))


</script>
